import { Controller } from "@hotwired/stimulus";

/**
 * study-actions (Stimulus controller)
 *
 * But:
 * - Conserver en mémoire le dernier payload envoyé par le pipeline
 *   "listing_details" (api-sync), pour que les boutons "Aperçu" et
 *   "Télécharger en PDF" POSTent toujours les critères courants — et non
 *   uniquement les valeurs initiales du formulaire au chargement.
 *
 * Comportement:
 * - À chaque `remote:update:start` ou `remote:update:success` reçu sur l'élément
 *   (canal "listing_details"), on sérialise `e.detail.payload` dans un input
 *   caché `payload` du formulaire. Ce payload est strictement le même que
 *   celui POSTé à `api/v1/simulator/get_details`.
 * - À la soumission, le serveur peut décoder ce JSON et reconstruire le payload
 *   exactement comme lors du calcul affiché à l'écran.
 */
export default class extends Controller {
  static targets = ["payload", "form"];
  static values = { channel: { type: String, default: "listing_details" } };

  connect() {
    this.onUpdate = (e) => {
      try {
        const channel = e?.detail?.channel;
        if (channel && channel !== this.channelValue) return;
        const payload = e?.detail?.payload;
        if (!payload) return;
        this.writePayload(payload);
      } catch (_) {}
    };
    document.addEventListener("remote:update:start", this.onUpdate);
    document.addEventListener("remote:update:success", this.onUpdate);
  }

  disconnect() {
    try { document.removeEventListener("remote:update:start", this.onUpdate); } catch (_) {}
    try { document.removeEventListener("remote:update:success", this.onUpdate); } catch (_) {}
  }

  writePayload(payload) {
    if (!this.hasPayloadTarget) return;
    try {
      this.payloadTarget.value = JSON.stringify(payload);
    } catch (_) {
      this.payloadTarget.value = "";
    }
  }
}
